// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2DS21","itemTitle":"ClientEmergencyInfo_itemTitle__1WzZk","itemText":"ClientEmergencyInfo_itemText__Il8h-"};